var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-tracker"},_vm._l((_vm.numPages),function(num,index){return _c('div',{key:num,staticClass:"circle",class:{ selected: index == _vm.currentPage, active: index <= _vm.currentPage }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }